import $ from "jquery";
import { useEffect, useState } from "react";

window.$ = $;
window.jQuery = $;

const curUrl = window.location.href;

const url = new URL(curUrl);
console.log(url);
const params = new URLSearchParams(url.search);
console.log(params);

$(document).ready(function () {
  var currentCategory = $("#category").val();
  var boardType = $("#boardType").val();
  var searchKeyword = $("#searchKeyword").val();

  // console.log(boardType);
  // console.log(searchKeyword);

  // 탭 네임이 있는 경우 탭 활성화
  var openTabName = $("#openTabName").val();
  if (openTabName != null && openTabName != "") {
    openTab("tab-" + openTabName);
  }

  const changeH3 = document.querySelector(".gallery_section > h3");
  const changeBc = document.querySelector(".support_contents > h3");
});

/* Tab Script */
function openTab(tabName) {
  $("#category").val(tabName.replace("tab-", ""));
  if ($("#openTabName") !== null) {
    $("#openTabName").val(tabName.replace("tab-", ""));
    loadPageTitle();
  }
}

// 탭 변경에 따른 화면 타이틀 변경
function loadPageTitle() {
  const subPath = $("#openTabName").val(); // 'path'

  // lang
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search);
  var lang = params.get("lang");

  //console.log("Param Language : " + lang);
  if (lang == null) {
    lang = $("#slang").val();
  }
  //console.log("Session Language : " + lang);

  var title = "";

  if (lang == "en_US") {
    title = subPath;
  } else {
    if (subPath == "catalogue") {
      title = "카타로그";
    } else if (subPath == "usermanual") {
      title = "제품설명서";
    } else if (subPath == "warranty") {
      title = "제품보증서";
    } else if (subPath == "inquiry") {
      title = "제품문의";
    } else if (subPath == "popup") {
      title = "팝업";
    }
  }
  $("#bc").text(title);
}

// To the Top Scroll

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.getElementById("scrollTopBtn").style.display = "flex";
    document.getElementById("callChatbot").style.display = "flex";
    if (document.getElementById("logoutBtn") != null) {
      document.getElementById("logoutBtn").style.display = "flex";
    }
    if (document.getElementById("callChatbot") != null) {
      document.getElementById("callChatbot").style.display = "flex";
    }
  } else {
    document.getElementById("scrollTopBtn").style.display = "none";
    document.getElementById("callChatbot").style.display = "none";
    if (document.getElementById("logoutBtn") != null) {
      document.getElementById("logoutBtn").style.display = "none";
    }
    if (document.getElementById("callChatbot") != null) {
      document.getElementById("callChatbot").style.display = "none";
    }
  }
}

$(document).ready(function () {
  $(window).scroll(function () {
    var position = $(window).scrollTop();
    if (position > 112) {
      // 탑버튼 보여줄 스크롤 위치지정
      //    $('#scrollTopBtn').slideDown("slow");
      $("#scrollTopBtn").css("display", "flex").fadeIn("slow");
    } else {
      $("#scrollTopBtn").css("display", "none").fadeOut("slow");
    }
  });

  $("#scrollTopBtn").click(function () {
    $("body,html").animate({ scrollTop: 0 }, 500); // 클릭시 스크롤 탑으로 이동
  });

  //function scrollToTop() {
  //    document.body.scrollTop = 0; /* For Safari */
  //    document.documentElement.scrollTop = 0; /* For Chrome, Firefox, IE and Opera */
  //}
});
